import { execute } from "../../features/lazy-load";
import epica from "../../features/epica";

export const analysisMixin = {
    methods: {
        changeTab() {
            setTimeout(() => {
                execute();
                epica();
                googletag.cmd.push(function () {
                    googletag.pubads().refresh([window.adSlots["div-gpt-ad-50"]]);
                });
            }, 100);
        }
    }
};